// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"y0-z","subtitle":"z0-z","wrapper":"A0-z","leftArrow":"B0-z","rightArrow":"C0-z"};